import { Component, OnInit, OnDestroy } from '@angular/core';
import { SITE_LINKS } from '../site-links';

@Component({
    selector: 'app-story',
    standalone: false,
    templateUrl: './story.component.html',
    styleUrls: ['./story.component.css']
})
export class StoryComponent implements OnInit, OnDestroy {
  readonly links = SITE_LINKS;

    ngOnInit(): void {
        // Initialize scroll animations
        this.initScrollAnimations();
    }

    ngOnDestroy(): void {
        // Cleanup if needed
    }

    /**
     * Initialize Intersection Observer for scroll animations
     */
    private initScrollAnimations(): void {
        const observerOptions = {
            threshold: 0.1,
            rootMargin: '0px 0px -50px 0px'
        };

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('visible');
                }
            });
        }, observerOptions);

        // Observe all fade-in elements after view init
        setTimeout(() => {
            document.querySelectorAll('.fade-in').forEach(el => {
                observer.observe(el);
            });
        }, 100);
    }

    /**
     * Smooth scroll to section
     */
    scrollToSection(sectionId: string): void {
        const element = document.getElementById(sectionId);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    }
}